<div class="login-title-section">
  <fgb-errors></fgb-errors>
</div>

<div class="form-group">
  <button (click)="loginTM()" class="btn btn-primary text-white btn-block login-button font-size-14">
    <span>Login with</span>
    <span><img [src]="'images/ticketmaster.svg' | contentAssetImage" class="tm-logo ps-2 mb-1" /></span>
  </button>
</div>
